/* eslint-disable react/no-string-refs */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import IconButton from '../../Buttons/IconButton/IconButton';
import { TString } from '../../Response/Utils';
import SmileIcon from '../../../../../assets/imgs/smile.png';
import AttachmentIcon from '../../../../../assets/imgs/attachment.png';
import { SendIconButton } from '../../Buttons/IconButton/Icons';
let self;
class Mic extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isToggleOn: false,
			totalTO: '',
			intermedTO: '',
		};
	}
	initRecord() {
		let playButton = this.refs.mic;
		let totalTO = this.state.totalTO;
		let intermedTO = this.state.intermedTO;

		/*
			playButton.addEventListener('click',  (e) => {
				if (isToggleOn) {
					playButton.dispatchEvent(new Event('pause'));
				} else {
					//console.log("dispatching play");

					if(!playButton.classList.contains("mic")) 
						return;
					if(this.props.isSpeech && !JSON.parse(this.props.isSpeech)){
						console.log("Request the Admin to enable voice support ! :) ")
						this.removeMicComponent();
						return
					}

					playButton.dispatchEvent(new Event('play'));
				}
			}, true);
		*/

		playButton.addEventListener('pause', (e) => {
			this.setState(
				{
					isToggleOn: false,
				},
				() => {
					// enable text to speech functionality
					this.props.toggleSpeakingFunctionality(true);
					if (totalTO) {
						clearTimeout(totalTO);
					}
					if (intermedTO) {
						clearTimeout(intermedTO);
					}
					playButton.classList.remove('recording');
					//set the input in state
					let mockEvent = new Event('keyup');
					let inputBox = document.getElementById('chatInput');
					inputBox.dispatchEvent(mockEvent);
					this.props.handleInput(inputBox.innerText);

					// self.props.handleInput.call(self, mockEvent);
					self.props.handleKeyUp.call(self, { keyCode: 13, mic: true });
					//playButton.classList.remove("mic")
					//playButton.click();
				}
			);
		});
	}

	isMicEnabled() {
		return this.props.isSpeech ? JSON.parse(this.props.isSpeech) : false;
	}

	isMicVisible() {
		return this.refs.mic.classList.contains('mic');
	}

	handleClick() {
		if (this.isMicEnabled() && this.isMicVisible()) {
			if (this.state.isToggleOn) {
				this.refs.mic.dispatchEvent(new Event('pause'));
			} else {
				// stop audio output for already generated audio
				this.props.stopSpeaking();
				// disable the text to speech functionality
				this.props.toggleSpeakingFunctionality(false);
				this.refs.mic.dispatchEvent(new Event('play'));
			}
		} else {
			// handle inputSubmit
			this.removeMicComponent();
			this.props.handleSubmit.call(this);
		}
	}

	removeMicComponent() {
		let micClassNames = this.refs.mic.classList;
		if (micClassNames.contains('mic')) {
			this.refs.mic.classList.remove('mic');
		}
	}

	componentDidMount() {
		self = this;
		if (this.props.isSpeech && !JSON.parse(this.props.isSpeech)) {
			//speech is not enabled
			this.removeMicComponent();
		}
		//if(this.refs.mic.classList.contains("mic")){
		this.initRecord();
		//};
		let synth = window.speechSynthesis;
		let totalTO = this.state.totalTO;
		let intermedTO = this.state.intermedTO;
		let botId = this.props.botId;
		// let locale = this.props.currentLanguageCode;

		if (!window.AudioContext) {
			console.log("Web Audio isn't available in your browser.");
			return;
		}

		let SAMPLE_RATE = 16000;
		let SAMPLE_SIZE = 16;

		let playButton = this.refs.mic;

		var context = new AudioContext({ sampleRate: SAMPLE_RATE });
		playButton.addEventListener('pause', () => {
			this.setState(
				{
					isToggleOn: false,
				},
				() => {
					// enable text to speech functionality
					this.props.toggleSpeakingFunctionality(true);
					context.suspend.call(context);
				}
			);
		});
		playButton.addEventListener('play', () => {
			this.setState(
				{
					isToggleOn: true,
				},
				() => {
					context.resume.call(context);
				}
			);
		});
		function initWebsocket(audioPromise) {
			var socket;
			var sourceNode;
			// Create a node that sends raw bytes across the websocket
			// var scriptNode = context.createScriptProcessor(4096, 1, 1);
			var scriptNode = context.createScriptProcessor(16384, 1, 1);
			// Need the maximum value for 16-bit signed samples, to convert from float.
			var MAX_INT = Math.pow(2, 16 - 1) - 1;
			scriptNode.addEventListener('audioprocess', function(e) {
				var floatSamples = e.inputBuffer.getChannelData(0);
				// The samples are floats in range [-1, 1]. Convert to 16-bit signed
				// integer.
				socket.send(
					Int16Array.from(
						floatSamples.map(function(n) {
							return n * MAX_INT;
						})
					)
				);
			});

			function newWebsocket() {
				self.props.getLoader(true);
				var websocketPromise = new Promise(function(resolve, reject) {
					//var socket = new WebSocket('wss://' + location.host + '/transcribe');
					// let wsurl = 'wss://' + 'speech.senseforth.com' + '/transcribe';
					let wsurl =
						'wss://' +
						window['BASE_URL'].replace(/(^\w+:|^)\/\//, '') +
						'/speech/sftranscribe';
					var socket = new WebSocket(wsurl);
					// var socket = new WebSocket(
					//   'wss://' + 'speech.senseforth.com' + '/transcribe'
					// );
					//var socket = new WebSocket('wss://' + 'localhost:8443' + '/transcribe');
					socket.addEventListener('open', resolve);
					socket.addEventListener('error', reject);
				});

				Promise.all([audioPromise, websocketPromise])
					.then(function(values) {
						self.props.getLoader(false);
						//var playButton = document.getElementsByClassName("mic")[0];
						playButton.classList.remove('record');
						playButton.classList.remove('recorder-loading');
						playButton.classList.add('recording');
						if (totalTO) {
							clearTimeout(totalTO);
						}
						totalTO = setTimeout(function() {
							if (intermedTO) {
								clearTimeout(intermedTO);
							}
							playButton.dispatchEvent(new Event('pause'));
						}, 30000);

						var micStream = values[0];
						socket = values[1].target;

						// If the socket is closed for whatever reason, pause the mic
						socket.addEventListener('close', function(e) {
							playButton.dispatchEvent(new Event('pause'));
						});
						socket.addEventListener('error', function(e) {
							console.log('Error from websocket', e);
							playButton.dispatchEvent(new Event('pause'));
						});

						function startByteStream() {
							// Hook up the scriptNode to the mic
							sourceNode = context.createMediaStreamSource(micStream);
							sourceNode.connect(scriptNode);
							scriptNode.connect(context.destination);
						}
						function onTranscription(e) {
							if (intermedTO) {
								clearTimeout(intermedTO);
							}
							var result = e.data && JSON.parse(e.data);

							//insert this line in prod!!!
							var inputBox = document.getElementById('chatInput');
							//var playButton = this.refs.mic;
							intermedTO = setTimeout(function() {
								if (totalTO) {
									clearTimeout(totalTO);
								}
								playButton.dispatchEvent(new Event('pause'));
							}, 3000);
							if (result.output) {
								//console.log(result.alternatives_[0]);
								inputBox.innerText = result.output.response;
							}
						}
						// Send the initial configuration message. When the server acknowledges
						// it, start streaming the audio bytes to the server and listening for
						// transcriptions.
						socket.addEventListener('message', onTranscription);
						startByteStream();

						socket.send(
							JSON.stringify({
								sampleRate: SAMPLE_RATE,
								locale: self.props.currentLanguageCode,
								botID: encodeURIComponent(botId),
							})
						);
					})
					.catch((e) => {
						self.props.getLoader(false);
						console.log.bind(console);
					});
			}

			function closeWebsocket() {
				scriptNode.disconnect();
				if (sourceNode) sourceNode.disconnect();
				if (socket && socket.readyState === socket.OPEN) socket.close();
			}

			function toggleWebsocket(e) {
				var context = e.target;
				if (context.state === 'running') {
					newWebsocket();
				} else if (context.state === 'suspended') {
					closeWebsocket();
				}
			}

			// When the mic is resumed or paused, change the state of the websocket too
			context.addEventListener('statechange', toggleWebsocket);
			// initialize for the current state
			toggleWebsocket({ target: context });
		}
		// The first time you hit play, connect to the microphone
		playButton.addEventListener(
			'play',
			() => {
				this.setState(
					{
						isToggleOn: true,
					},
					() => {
						var audioPromise = navigator.mediaDevices.getUserMedia({
							audio: {
								echoCancellation: true,
								channelCount: 1,
								sampleRate: {
									ideal: SAMPLE_RATE,
								},
								sampleSize: SAMPLE_SIZE,
							},
						});
						this.props.getLoader(true);
						audioPromise
							.then(() => {
								this.props.getLoader(false);
							})
							.catch((e) => {
								this.props.getLoader(false);
								console.log.bind(e);
							});

						initWebsocket(audioPromise);
					}
				);
			},
			{ once: true }
		);
	}

	render() {
		return (
			<div
				className={
					this.props.channel === 'whatsapp'
						? 'whatsapp-sf-btn-wrapper'
						: 'sf-btn-wrapper'
				}
			>
				{/* <img src={SmileIcon} alt='' />
				<img src={AttachmentIcon} alt='' /> */}
				<div
					onClick={
						this.props.chatInput.length > 0 && this.handleClick.bind(this)
					}
					id='send-msg'
					ref='mic'
					// style={
					// 	!JSON.parse(this.props.isSpeech)
					// 		? { background: 'none', pointerEvents: 'none', cursor: 'initial' }
					// 		: {}
					// }
					className={`sf-input-btns ${
						this.props.isSpeech && JSON.parse(this.props.isSpeech)
							? this.state.isToggleOn
								? 'mic recording'
								: 'mic'
							: ''
					}`}
				>
					{this.props.chatInput.trim().length > 0 ? (
						<React.Fragment>
							{this.props.selectedTheme === 'monaco' ||
							this.props.selectedTheme === 'E-commerce Chat' ? (
								<svg
									xmlns='http://www.w3.org/2000/svg'
									id='send-icn'
									width='13.014'
									height='15.069'
									viewBox='0 0 13.014 15.069'
								>
									<g
										id='Path_6'
										data-name='Path 6'
										transform='translate(13.014) rotate(90)'
									>
										<path
											d='M 0.9947404265403748 12.04445552825928 L 7.534533500671387 0.7484385967254639 L 14.07432556152344 12.04445266723633 L 7.714113712310791 8.575236320495605 L 7.534543514251709 8.477286338806152 L 7.354973316192627 8.575236320495605 L 0.9947404265403748 12.04445552825928 Z'
											stroke='none'
											fill='var(--selectedColor)'
										/>
										<path
											d='M 7.534533500671387 1.496898651123047 L 1.989492416381836 11.07470607757568 L 7.534543514251709 8.050126075744629 L 13.0795726776123 11.0747013092041 L 7.534533500671387 1.496898651123047 M 7.534533500671387 -3.814697265625e-06 L 15.06906318664551 13.01419639587402 L 7.534543514251709 8.904445648193359 L 3.814697265625e-06 13.01419639587402 L 7.534533500671387 -3.814697265625e-06 Z'
											stroke='none'
											fill='var(--selectedColor)'
										/>
									</g>
								</svg>
							) : (
								<SendIconButton
									fill={
										this.props.data.colorMode === 'dark'
											? 'var(--selectedColor)'
											: this.props.data.colorScale[4]
									}
								/>
							)}
						</React.Fragment>
					) : null}
					{this.props.chatInput.length <= 0 &&
					this.props.channel === 'whatsapp' ? (
						<IconButton
							size={'normal'}
							image={'mic'}
							fill={this.props.foreground}
							className='whatsapp-mic'
							variant={'empty'}
							pulse={this.state.isToggleOn}
							title={TString({
								labelName: 'voiceLabel',
								langCode: this.state.currentLanguageCode,
								fromClass: true,
							})}
						/>
					) : this.props.data.searchEnabled.includes('voice') &&
					  this.props.chatInput.length === 0 &&
					  this.props.selectedTheme === 'Default' ? (
						//this.props.data.searchEnabled.includes('voice') ? (
						<IconButton
							size={'normal'}
							image={'mic'}
							fill={this.props.data.colorScale[4]}
							variant={'empty'}
							onClick={() => {
								this.props.enableVoiceModal();
							}}
							title={TString({
								labelName: 'voiceLabel',
								langCode: this.state.currentLanguageCode,
								fromClass: true,
							})}
						/>
					) : null}
				</div>
			</div>
		);
	}
}

let SFMic = {
	Mic: Mic,
};

export default SFMic;
